import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/themes";
import { router } from "./router.js";
import { ThemeProvider, useTheme } from "./state/themeState.js";
import { ViewSettingsProvider } from "./state/viewSettingsState.js";

window.addEventListener("error", (e) =>
  console.error("[global error]", e.error),
);
window.addEventListener("unhandledrejection", (e) =>
  console.error("[unhandled rejection]", e.reason),
);

function ClerkWithTheme({ children }: { children: React.ReactNode }) {
  const { isDark } = useTheme();
  return (
    <ClerkProvider
      publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
      appearance={isDark ? dark : undefined}
    >
      {children}
    </ClerkProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <ViewSettingsProvider>
      <ClerkWithTheme>
        <RouterProvider router={router} />
      </ClerkWithTheme>
    </ViewSettingsProvider>
  </ThemeProvider>,
);
